import { leagueFetch } from '@leagueplatform/league-fetch';
import { MASONRY_NODE_DISMISS_ENDPOINT } from '../constants/masonry-node-api';

export const postMasonryNodeDismiss = async ({
  nodeIds,
  id,
  dismissedUntil,
  forceProcess,
}: {
  nodeIds: string[];
  id: string;
  dismissedUntil?: string;
  forceProcess?: boolean;
}) => {
  const response = await leagueFetch(MASONRY_NODE_DISMISS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      data: {
        id,
        type: 'dismissed',
        attributes: { nodeIds, dismissedUntil, forceProcess },
      },
    }),
  });

  if (response.ok) {
    return true;
  }

  throw new Error(`Masonry Dismiss Action Error:${response.status}`);
};
